import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { CustomerConst } from '@app/constants/customer-const';
import { Customer } from '@app/models/customer';


@Component({
    selector: 'app-customer-advanced-search-form-result',
    templateUrl: './advanced-search-form-result.component.html',
    styleUrls: ['./advanced-search-form-result.component.css'],
    standalone: false
})
export class AdvancedSearchFromResultComponent implements OnChanges {

  selectedCustomer: Customer;
  
  @Input() customers: Array<Customer>;
  @Input() totalCustomers: number;
  @Input() pageSizeCustomers: number;
  @Input() displaySearchDialog: boolean;
  @Output() onSubmit = new EventEmitter<Customer>();
  @Output() onCancel = new EventEmitter();
  @Output() onLoadData = new EventEmitter<any>();

  constructor() { }


  ngOnChanges()
  {
    if(!this.customers){
      this.customers = new Array<Customer>();
    }
  }

  getPassportNumber(customer: Customer) {
    if (customer.identities) {
      let passport = customer.identities.find(p => (p.type == CustomerConst.IDENTITY_TYPE.NATIONAL_PASSPORT || p.type == CustomerConst.IDENTITY_TYPE.FOREIGN_PASSPORT));
      if (passport) {
        return passport.serialNumber;
      }
    }
    return "";
  }
  
  cancelSearch() {
    this.onCancel.emit();
  }

  
  onSelect() {
    if(this.selectedCustomer)
    {
      this.onSubmit.emit(this.selectedCustomer);
    }
  }

  pageChangeEvent(event){
    this.onLoadData.emit(event);
  }

  selectCustumner(customer){
    this.selectedCustomer = customer;
  }
}
